import '../sass/styles.scss'

import App from 'next/app'
import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import withRedux from 'next-redux-wrapper'
import withReduxSaga from 'next-redux-saga'
import { appWithTranslation } from '../i18n'
import configureStore from '../redux/configureStore'
import Head from 'next/head'
import { isServer } from '../utils/platform'
import BugSnag from '../config/bugsnag'
const isServerEnv = isServer()

interface Props {
  store: any
}

class FlexApp extends App<Props> {
  render() {
    const { Component, pageProps, store } = this.props

    if (!isServerEnv) {
      return (
        <Provider store={store}>
          <Head>
            <meta
              name="viewport"
              content="initial-scale=1, minimum-scale=1, maximum-scale=1, width=device-width"
              key="viewport"
            />
          </Head>
          <BugSnag.ErrorBoundary>
            <PersistGate persistor={store.__PERSISTOR} loading={null}>
              <Component {...pageProps} />
            </PersistGate>
          </BugSnag.ErrorBoundary>
        </Provider>
      )
    } else {
      return (
        <Provider store={store}>
          <PersistGate persistor={store.__PERSISTOR} loading={null}>
            <Component {...pageProps} />
          </PersistGate>
        </Provider>
      )
    }
  }
}

export default withRedux(configureStore)(withReduxSaga(appWithTranslation(FlexApp)))
